import React from 'react';
import './main.css';

export default () => (
  <footer>
    <a href="https://www.linkedin.com/in/damonself">
      © Damon Self
    </a>
    <section className="logos">
      <a href="https://www.instagram.com/hipstuhd/">
        <img src="https://seeklogo.com/images/I/instagram-logo-766240E9D9-seeklogo.com.png" alt="Instagram"></img> 
      </a>
      <a href="https://github.com/DaemonSpelledWrong">
      <img src="https://cdn0.iconfinder.com/data/icons/shift-logotypes/32/Github-512.png" alt="Github"></img>
      </a>
    </section>
  </footer>
)